import localforage from 'localforage';

const draftsDb = localforage.createInstance({
  name: 'round-offline',
  storeName: 'drafts'
});

export async function putRoundDraft(roundId, draft) {
  if (!roundId) throw new Error('putRoundDraft: missing roundId');
  const key = `draft_round_${roundId}`;
  await draftsDb.setItem(key, draft);
  return key;
}

export async function getRoundDraft(roundId) {
  if (!roundId) return null;
  return await draftsDb.getItem(`draft_round_${roundId}`);
}

export async function removeRoundDraft(roundId) {
  if (!roundId) return;
  await draftsDb.removeItem(`draft_round_${roundId}`);
}

export async function hasRoundDraft(roundId) {
  if (!roundId) return false;
  const v = await draftsDb.getItem(`draft_round_${roundId}`);
  return !!v;
}

export async function listRoundDrafts() {
  const keys = await draftsDb.keys();
  const drafts = [];

  for (const key of keys) {
    if (!String(key).startsWith('draft_round_')) continue;
    const draft = await draftsDb.getItem(key);
    drafts.push({ key, draft });
  }

  return drafts;
}


export async function removeDraftsForRound(roundId) {
  const key = `draft_round_${roundId}`;
  await draftsDb.removeItem(key);
}


